import * as Sentry from '@sentry/react';
import { tanstackRouterBrowserTracingIntegration } from '@sentry/react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App, router } from './app/App';
import '@drisk-ai/design-system/globals.css';
import './app/styles/index.css';
import { Toaster } from 'sonner';

const sentryDsn = import.meta.env.VITE_ADMIN_SENTRY_DSN;

if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    integrations: [
      tanstackRouterBrowserTracingIntegration(router),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    environment: import.meta.env.VITE_APP_STAGE,
    sendDefaultPii: true,
    debug: false,
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Toaster />
    <App />
  </StrictMode>,
);
